<template>
    <div class="custom-view-calender" :style="type === 'day' || type === 'listWeek' ? 'min-height: calc(100vh - 249px);' : ''">
        <div v-if="type === 'week' || type === 'day'" class="week-calender">
            <template v-for="day in dateList">
                <div :key="day.day" class="week-calender-row">
                    <div v-if="type === 'week'" class="week-row-date">
                        <div style="position: absolute; width: 100%; top: 50%; margin: auto; transform: translateY(-50%)">
                            <span style="font-size: 16px; color: #000000; font-weight: bold">{{ day.monthDay }}</span>
                            &nbsp;&nbsp;
                            <span style="color: #666666; font-size: 13px">{{ day.weekday }}</span>
                        </div>
                    </div>
                    <div v-if="type === 'day'" class="week-row-date">
                        <div style="position: absolute; width: 100%; top: 50%; margin: auto; transform: translateY(-50%)">
                            <span style="font-size: 16px; color: #000000; font-weight: bold">{{ day.day }}</span>
                        </div>
                    </div>
                    <div class="week-row-data" :class="{ 'day-row-data': type === 'day', 'week-empty-data': type === 'week' && day.list.length === 0 }" @click="calendeClick(day)">
                        <template v-if="day.list.length > 0">
                            <template v-for="(item, index) in day.list">
                                <div v-if="rowMaxData === null || index + 1 <= rowMaxData" :key="item.id" @click.stop="calendeClick(item)">
                                    <span><svg-icon :icon-class="item.type === 'calender' ? 'personcalender' : 'official'" /></span>
                                    &nbsp;
                                    <span v-if="type !== 'day'">{{ item.start.split(' ')[1].substr(0, 5) }}&nbsp;</span>
                                    <span>{{ item.title }}</span>
                                </div>
                            </template>
                        </template>
                        <div v-else style="line-height: 60px; color: #999">
                            <div v-text-lbl="'nullmoment'">暂无日程！</div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div v-if="type === 'day' && replenishHeight !== 0" :style="{ height: replenishHeight + 'px' }" style="display: flex; border-top: 1px solid #ebeef5">
            <div style="width: 140px; background: #f8f8f8; border-right: 1px solid #ebeef5" />
            <div style="flex: 1">
                <div v-if="dateList.length === 0" style="text-align: center; margin-top: 30px">
                    <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                    <br />
                    <span style="font-size: 15px; color: #dbdbdb" v-text-lbl="'nullmoment'">暂无日程！</span>
                </div>
            </div>
        </div>
        <div v-if="type === 'listWeek'" class="listWeek-calender">
            <template v-if="dateList.length > 0">
                <template v-for="day in dateList">
                    <div :key="day.day" class="listWeek-row">
                        <div class="listWeek-title">
                            <span>{{ day.weekday }}</span>
                            <span style="margin-left: 10px">{{ day.format }}</span>
                        </div>
                        <div class="listWeek-content">
                            <template v-for="item in day.list">
                                <div :key="item.id" @click="calendeClick(item)">
                                    <span style="font-size: 16px；">{{ item.start.split(' ')[1].substr(0, 5) }}</span>
                                    &nbsp;&nbsp;
                                    <span class="icon" />
                                    &nbsp;&nbsp;
                                    <span>{{ item.title }}</span>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </template>
            <div v-else style="text-align: center; margin-top: 30px">
                <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                <br />
                <span style="font-size: 15px; color: #dbdbdb" v-text-lbl="'nullmoment'">暂无日程！</span>
            </div>
        </div>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    components: {},
    props: {
        type: { type: String, default: '' },
        viewData: {
            type: Array,
            default: function () {
                return []
            }
        },
        startDate: { type: String, default: null },
        endDate: { type: String, default: null },
        sundayStart: { type: Boolean, default: true },
        click: { type: Function, default: null },
        rowMaxData: { type: Number, default: null }
    },
    data() {
        return {
            i18npkg: 'ecoa',
            moduleCode: 'calendar',
            dateList: [],
            replenishHeight: 0
        }
    },
    computed: {},
    watch: {
        type: {
            handler(val) {
                if (val === 'week') {
                    this.getNowWeek()
                } else if (val === 'day') {
                    this.getDatelist()
                } else if (val === 'listWeek') {
                    this.getListWeek()
                }
            },
            immediate: true
        },
        viewData: {
            handler() {
                if (this.type === 'week') {
                    this.getNowWeek()
                } else if (this.type === 'day') {
                    this.getDatelist()
                } else if (this.type === 'listWeek') {
                    this.getListWeek()
                }
            },
            deep: true
        }
    },
    created() {},
    beforeDestroy() {
        window.removeEventListener('resize', this.onresize, false)
    },
    mounted() {
        window.addEventListener('resize', this.onresize, false)
    },
    methods: {
        // 本周日历
        getNowWeek() {
            const startWeekDate = new Date(this.startDate)
            let differ = 0
            if (this.endDate !== null) {
                differ = parseInt((new Date(this.endDate).getTime() - startWeekDate.getTime()) / 24 / 60 / 60 / 1000) + 1
            } else {
                differ = 7
            }

            const time = new Date()
            const arry = []
            // const weekobj = { 0: '周日', 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六' }
            const weekobj = { 0: this.$tx('common.Sunday', '周日'), 1: this.$tx('common.Monday', '周一'), 2: this.$tx('common.Tuesday', '周二'), 3: this.$tx('common.Wednesday', '周三'), 4: this.$tx('common.Thursday', '周四'), 5: this.$tx('common.Friday', '周五'), 6: this.$tx('common.Saturday', '周六') }

            for (let i = 0; i < differ; i++) {
                const t = new Date(startWeekDate.getTime() + i * 24 * 60 * 60 * 1000)
                const obj = {
                    day: t.getDate(),
                    date: moment(t).format('YYYY-MM-DD'),
                    monthDay: moment(t).format('MM-DD'),
                    weekday: weekobj[t.getDay()],
                    isToday: moment(t).format('YYYY-MM-DD') === moment(time).format('YYYY-MM-DD'),
                    list: []
                }
                this.viewData.forEach((item) => {
                    if (obj.date === item.start.split(' ')[0] || obj.date === item.end.split(' ')[0] || (obj.date > item.start.split(' ')[0] && obj.date < item.end.split(' ')[0])) {
                        obj.list.push(item)
                    }
                })
                arry.push(obj)
            }
            this.dateList = arry
        },
        getDatelist() {
            const dayobj = {}
            this.viewData.forEach((item) => {
                const time = item.start.split(' ')[1].substr(0, 5)
                if (!dayobj[time]) {
                    dayobj[time] = []
                    dayobj[time].push(item)
                } else {
                    dayobj[time].push(item)
                }
            })
            const arry = []
            for (const key in dayobj) {
                const obj = {
                    day: key,
                    date: moment(this.startDate).format('YYYY-MM-DD'),
                    monthDay: moment(this.startDate).format('YYYY-MM-DD').substr(5, 5),
                    list: dayobj[key]
                }
                arry.push(obj)
            }
            this.dateList = arry
            this.replenishHeight = 0
            this.$nextTick(() => {
                this.replenishHeight = this.getReplenishHeight()
            })
        },
        getListWeek() {
            const dayobj = {}
            this.viewData.forEach((item) => {
                const time = item.start.split(' ')[0]
                if (!dayobj[time]) {
                    dayobj[time] = []
                    dayobj[time].push(item)
                } else {
                    dayobj[time].push(item)
                }
            })
            const arry = []
            // const weekobj = { 0: '周日', 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六' }
            const weekobj = { 0: this.$tx('common.Sunday', '周日'), 1: this.$tx('common.Monday', '周一'), 2: this.$tx('common.Tuesday', '周二'), 3: this.$tx('common.Wednesday', '周三'), 4: this.$tx('common.Thursday', '周四'), 5: this.$tx('common.Friday', '周五'), 6: this.$tx('common.Saturday', '周六') }
            for (const key in dayobj) {
                const obj = {
                    day: Number(key.split('-')[2]),
                    format: moment(new Date(key)).format('YYYY年MM月DD日'),
                    date: moment(this.startDate).format('YYYY-MM-DD'),
                    weekday: weekobj[new Date(key).getDay()],
                    list: dayobj[key]
                }
                arry.push(obj)
            }
            this.dateList = arry
        },
        calendeClick(item) {
            if (this.click !== null) {
                this.click(item)
            }
            this.$emit('click', item)
        },
        onresize() {
            this.replenishHeight = 0
            this.$nextTick(() => {
                this.replenishHeight = this.getReplenishHeight()
            })
        },
        getReplenishHeight() {
            const parent = document.querySelector('.custom-view-calender')
            const calender = parent.querySelectorAll('.week-calender')

            let h = 2
            for (let i = 0; i < calender.length; i++) {
                h += calender[i].offsetHeight
            }

            return parent.offsetHeight - h
        }
    }
}
</script>

<style scoped lang="scss">
.custom-view-calender {
    border: 1px solid #ebeef5;
    border-radius: 2px;
    background: #fff;
    .week-calender {
        .week-calender-row {
            display: flex;
            &:not(:last-child) {
                border-bottom: 1px solid #ebeef5;
            }
            .week-row-date {
                width: 140px;
                text-align: center;
                background: #f8f8f8;
                border-right: 1px solid #ebeef5;
                min-height: 60px;
                // display: table;
                position: relative;
            }
            .week-row-data {
                flex: 1;
                color: #4a4a4a;
                font-size: 13px;
                & > div {
                    cursor: pointer;
                    padding: 8px 14px;
                    &:not(:last-child) {
                        border-bottom: 1px solid #ebeef5;
                    }
                    &:hover {
                        background: #f5f5f5;
                    }
                }
            }
            .day-row-data {
                line-height: 60px;
                padding: 0;
                & > div {
                    padding: 0 8px;
                }
            }
            .week-empty-data {
                display: table;
                height: 100%;
                & > div {
                    cursor: default;
                    display: table-cell;
                    vertical-align: middle;
                    padding: 0 8px;
                    &:hover {
                        background: #fff;
                    }
                }
            }
        }
    }
    .listWeek-calender {
        .listWeek-row {
            .listWeek-title {
                font-size: 14px;
                color: #1689fa;
                background: #f8f8f8;
                border-bottom: 1px solid #ebeef5;
                padding: 8px 14px;
            }
            .listWeek-content {
                & > div {
                    color: #4a4a4a;
                    font-size: 13px;
                    padding: 8px 14px;
                    cursor: pointer;
                    &:not(:last-child) {
                        border-bottom: 1px solid #ebeef5;
                    }
                    .icon {
                        position: relative;
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        &::after {
                            position: absolute;
                            content: '';
                            width: 10px;
                            height: 10px;
                            border-radius: 50%;
                            background: #1689fa;
                        }
                    }
                }
                & > div:hover {
                    background: #f5f5f5;
                }
            }
        }
    }
}
</style>
